import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { TableOptions } from "../../../../shared-kernel/components/Table";
import {
  createAdapterToAccountType,
  createAdapterToAccountTypeEndpoint,
  createAdapterToFieldAccountTypeEndpoint
} from "../adapters/accountType.adapter";
import { AccountType, AccountTypeEndpoint, EndpointAccountTypeFiltered } from "../domain/accountType.model";
import { appConfig } from "../../../../config";
import { EndpointAccountType } from "../domain/accountType.model";
import { createAdapterToFilterBackend } from "../../../../utilities/paramsAdapter";

const BASE_ACCOUNTTYPE_URL = '/entidadesfinancieras/tiposcuentasbancarias'
const BASE_ACCOUNTTYPE_MUTATION_URL = '/entidadesfinancieras/tipocuentabancaria'
export const BASE_EXPORT_URL = `${appConfig.API_NODE_URL}/entidadesfinancieras/tiposcuentasbancarias/export`;

export const accountTypeApi = createApi({
  reducerPath: "ccountTypeApi",
  baseQuery: fetchBaseQuery({
    baseUrl: appConfig.API_NODE_URL,
    prepareHeaders: (headers: Headers) => {
      const APP_TOKEN = "app_token";
      const token = localStorage.getItem(APP_TOKEN);

      if (token) {
        headers.set("authorization", `${token}`);
      }

      return headers;
    },
    credentials: "include",
  }),
  refetchOnMountOrArgChange: true,
  tagTypes: ["AccountTypes", "AccountType"],
  endpoints: (builder) => ({
    getAccountType: builder.query<AccountType, number | undefined>({
      query: (id) => `${BASE_ACCOUNTTYPE_MUTATION_URL}/${id}`,
      transformResponse: (response: EndpointAccountType) => {
        return createAdapterToAccountType(response.Content)
      },
      providesTags:(_res, _err, id) => [{type: "AccountType", id: id?.toString()}],
    }),
    getAccountTypes: builder.query<any, TableOptions<AccountType>|undefined>({
      query: (params: TableOptions<AccountType>) => {
        const { page, pageSize, order, search, filters } = params || {};
        const adaptersFilter = filters?.map( f => createAdapterToFilterBackend(f,createAdapterToFieldAccountTypeEndpoint))
        const serializedFilters = adaptersFilter ? JSON.stringify(adaptersFilter) : undefined;
        const serializedOrder = order ? JSON.stringify({field:createAdapterToFieldAccountTypeEndpoint(order.field), order:order.order}) : undefined;
        return {
          url:`${BASE_ACCOUNTTYPE_URL}/filtros`,
          params: {
            page:page? page - 1: 0,
            pageSize,
            order: serializedOrder,
            search,
            filters:serializedFilters
          },
        }
      },
      providesTags: ["AccountTypes"],
      transformResponse: (response: EndpointAccountTypeFiltered, _meta, params: TableOptions<AccountType>) => {
        const page = params?.page ?? 1;
        const endpointResponse = response?.rows?.map((accountType: AccountTypeEndpoint) =>
            createAdapterToAccountType(accountType)
        );
        return {
          data: endpointResponse,
          page,
          total: response.total,
        };
      },
    }),

    createAccountType: builder.mutation<any, AccountType>({
      query: (data) => ({
        url: `${BASE_ACCOUNTTYPE_MUTATION_URL}`,
        method: "POST",
        body: {
          "Content": createAdapterToAccountTypeEndpoint(data)
        },
      }),
      invalidatesTags: ["AccountTypes"],
    }),
    updateAccountType: builder.mutation<any, AccountType>({
      query: (data: AccountType) => ({
        url: `${BASE_ACCOUNTTYPE_MUTATION_URL}`,
        method: "PUT",
        body: {
          "Content": createAdapterToAccountTypeEndpoint(data)
        },
      }),
      invalidatesTags: (_res, _err, data: AccountType) =>  ["AccountTypes", {type: 'AccountType', id: data?.id?.toString()}],
    }),
    deleteAccountType: builder.mutation<void, number>({
      query: (id) => ({
        url: `${BASE_ACCOUNTTYPE_MUTATION_URL}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["AccountTypes"],
    }),
  }),
});

export const {
  useGetAccountTypeQuery,
  useGetAccountTypesQuery,
  useCreateAccountTypeMutation,
  useUpdateAccountTypeMutation,
  useDeleteAccountTypeMutation
} = accountTypeApi;
